export default __webpack_public_path__ + "static/Aaron-Luboff-350x350-f6999be70fb3ee723600b17be9025bfd.jpg";